import { copApi } from 'api'
import { CommunityTag } from 'types/community-tags'
import { Practitioner } from 'types/practitioners'

export interface Carousel {
  tag: CommunityTag
  practitioner: Practitioner
}
export const fetchCarousel = () => copApi.get<Carousel[]>('/community-tags/carousel')
